<template>
    <div aria-hidden="true" aria-labelledby="modalFillInLabel" role="dialog" tabindex="-1" class="modal modal-default modal-delete in" id="modal-delete-note" style="display:block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <header class="modal-header">
            <strong>{{ __('Delete note') }}</strong>
            <p>{{ __('Do you really want to delete this note?') }}</p>
          </header>

          <div class="modal-body">
            <div class="btn-group">
              <VButton :label="__('Cancel')" @onClick="$emit('mode', 'list')" variant="secondary" />
              <VButton :label="__('Delete')" @onClick="$emit('remove')" type="submit" color="danger" />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    patientId: {
      type: Number,
      required: true
    },
    note: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: Object.assign({}, this.note)
    }
  },
  methods: {
    async submit() {
      const rolePrefix = this.user.role === 'coach' ? 'coaches' : 'doctors'

      await axios.put(`/${rolePrefix}/patients/${this.patientId}/notes/${this.note.id}`, this.form).then(r => r.data)

      this.$emit('update', this.form)
    }
  }
}
</script>
